import { PartnerType } from "@/app/utils/partners.enum";
import { httpClient } from "../http/httpClient";
import { MakeProposalResponse } from "../panService/makeProposal";

export async function createPanTransaction(payload: {
  customerId: string;
  linkName: string;
  type: PartnerType;
  providerData: Record<string, unknown>;
}) {
  const { data } = await httpClient
    .post<MakeProposalResponse>(
      `/self-hire/${payload.linkName}/transaction`,
      payload,
    )
    .catch((err) => {
      throw err?.response?.data || err;
    });

  return data;
}
